import { initFormController } from '@wix/form-viewer/controller';
import { FormApiContext } from '../utils';
import { WixFormsFieldProperties } from '../../../utils/state/types';

export const BOOKINGS_WIX_FORM_NAMESPACE = 'wix.bookings.v2.bookings';

export type InitWixFormControllerArgs = {
  formId: string;
  serviceIds?: string[];
};

export const initWixFormController = async ({
  flowApi,
  formId,
  serviceIds,
}: InitWixFormControllerArgs &
  FormApiContext): Promise<WixFormsFieldProperties> => {
  const { getFieldPropertiesByTarget } = await initFormController(
    {
      controllerConfig: flowApi.controllerConfig,
      environment: flowApi.environment,
      experiments: flowApi.experiments,
      panoramaClient: flowApi.panoramaClient,
      httpClient: flowApi.httpClient,
      getCurrencyFormatter: flowApi.getCurrencyFormatter,
      // TODO: When implementing Error Handler in bookings form and when wix form fix the type binding fix the any type
      errorHandler: flowApi.errorHandler as any,
    },
    {
      formId,
      namespace: BOOKINGS_WIX_FORM_NAMESPACE,
      ...(serviceIds
        ? {
            additionalMetadata: {
              serviceIds,
            },
          }
        : {}),
    },
  );

  return getFieldPropertiesByTarget(formId) as WixFormsFieldProperties;
};
